import { makeStyles } from '@mui/styles';

import Colors from 'configs/Colors';

const useStyles = makeStyles(() => ({
  wrapYearSelector: {
    marginTop: 16,
  },
  label: {
    color: '#0F0F0F',
    fontFamily: '"Readex Pro"',
    fontSize: 14,
    fontWeight: 200,
    lineHeight: '20px',
    letterSpacing: '0.56px',
  },
  require: {
    marginLeft: 6,
    color: Colors.Red6,
    fontSize: 18,
    fontWeight: 500,
  },
  datePicker: {
    width: '100%',
    '& .MuiOutlinedInput-input': {
      height: 'unset',
      padding: '12px 8px',
      fontSize: 14,
      lineHeight: 1.42858,
    },
  },
  datePickerDisable: {
    backgroundColor: Colors.GrayScale10,
  },
}));

export default useStyles;
